const sections = [
  { name: "Blog", url: "/blog" },
  { name: "Mentoría", url: "/p/mentoria" },
  { name: "Discord", url: "https://bit.ly/pintaapis" },
  { name: "Cursos", url: "/cursos" },
  { name: "About", url: "/p/sobre-mi" },
];

export default sections;
